// Where a signed-out link goes while its user signs in. The web OAuth
// round-trip comes back to origin + pathname with the tokens in the hash, so
// what the user opened is gone by the time AuthGate has a session:
//   • a route hash  — #/companies/<id>?panel=vault&file=… (a deep link)
//   • ?authorization_id=… — an MCP client's OAuth consent hand-off (app.jsx)
// login.jsx stashes both here before leaving for Microsoft and takes them
// back once the tokens are consumed. Nothing else in the query is kept
// (?login=1 is meant to be dropped by sign-in).
//
// sessionStorage: per tab, and it survives the trip to Supabase and back.
// No React, no DOM — `node --test` loads this exact file
// (test/auth_return_route.test.mjs). login.jsx reads window.AuthReturnRoute.

(function () {
  const KEY = 'atlas.returnTo';

  // Only an app route is worth keeping — never an auth callback's tokens.
  const isRouteHash = (hash) =>
    typeof hash === 'string' && hash.startsWith('#/') && !hash.includes('access_token=');

  const consentSearch = (search) => {
    let id = null;
    try { id = new URLSearchParams(search || '').get('authorization_id'); } catch (_) {}
    return id ? '?' + new URLSearchParams({ authorization_id: id }) : '';
  };

  // { search, hash } with only the parts worth restoring, or null for none.
  const pick = (loc) => {
    const hash = loc && isRouteHash(loc.hash) ? loc.hash : '';
    const search = loc && typeof loc.search === 'string' ? consentSearch(loc.search) : '';
    return hash || search ? { search, hash } : null;
  };

  // Reading window.sessionStorage can itself throw (storage blocked).
  const sessionStore = () => {
    try { return window.sessionStorage || null; } catch (_) { return null; }
  };

  // Remember where to come back to before the browser leaves for sign-in —
  // pass window.location. True when anything was kept.
  const save = (loc, storage = sessionStore()) => {
    const back = pick(loc);
    if (!back) return false;
    try { storage.setItem(KEY, JSON.stringify(back)); return true; } catch (_) { return false; }
  };

  // The saved { search, hash }, once: removed as it's read. null when none.
  const take = (storage = sessionStore()) => {
    let raw = null;
    try { raw = storage.getItem(KEY); } catch (_) { return null; }
    try { storage.removeItem(KEY); } catch (_) {}
    try { return pick(JSON.parse(raw)); } catch (_) { return null; }
  };

  window.AuthReturnRoute = { isRouteHash, save, take };
})();
